import React from 'react';

function ShopReceiptFooter(props) {
	
	return (
			<hr className="hr-line-no-margin-bottom" />
	);
}

export default ShopReceiptFooter;